type LocaleChangeMessage = { type: 'locale_change'; localeCode: string };
type DeviceSelectedMessage = { type: 'device_selected'; device: string };

declare global {
   interface Window {
      ReactNativeWebView?: {
         postMessage: (message: string) => void;
      };
   }
}

type ReactNativeMessage = LocaleChangeMessage | DeviceSelectedMessage;
export function sendReactNativeMessage(message: ReactNativeMessage) {
   if (typeof window === 'undefined') {
      return;
   }
   window.ReactNativeWebView?.postMessage(JSON.stringify(message));
}
